import { render, staticRenderFns } from "./AMQOMRJR.vue?vue&type=template&id=0ef545dd&scoped=true&"
import script from "./AMQOMRJR.vue?vue&type=script&lang=js&"
export * from "./AMQOMRJR.vue?vue&type=script&lang=js&"
import style0 from "./AMQOMRJR.vue?vue&type=style&index=0&id=0ef545dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef545dd",
  null
  
)

export default component.exports